import { InternalRefetchQueriesInclude } from "@uplift-ltd/apollo";
import React, { useMemo, useState } from "react";
import { ProductIdTypeEnum } from "__generated__/globalTypes";
import Button from "components/common/Button";
import CouponDiscount from "components/common/CouponDiscount";
import Loading from "components/common/Loading";
import { Price } from "components/common/Price/Price";
import { useDiscountOptionsFromSubscription } from "components/common/Price/utils";
import ProductPurchaseModal from "components/common/PurchaseModal/ProductPurchaseModal";
import { CURRENT_USER_QUERY } from "hooks";
import { CombinedEvent, CombinedEventProduct, EVENT_FOR_USER_QUERY } from "./queries";

type EventRegisterProps = {
  event: CombinedEvent;
  product: CombinedEventProduct;
  title: string | null | undefined;
};

const SidebarRegister: React.FC<EventRegisterProps> = ({ event, product, title }) => {
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [hasJustPurchased, setHasJustPurchased] = useState(false);
  const [activeSubscriptionDiscountId, setActiveSubscriptionDiscountId] = useState<
    string | undefined
  >();

  const onClickPurchase = () => setPaymentModalOpen(true);
  const onCloseModal = () => setPaymentModalOpen(false);

  const modalTitle = "Event Enrollment";
  const type = "event";
  const canPurchaseWithCredits = false;
  const creditCost = 0;

  const discountInfo = useDiscountOptionsFromSubscription(product, activeSubscriptionDiscountId);

  const refetchQueries: InternalRefetchQueriesInclude = useMemo(() => {
    return [
      { query: CURRENT_USER_QUERY },
      ...product.events.map(productEvent => ({
        query: EVENT_FOR_USER_QUERY,
        variables: {
          id: productEvent.id,
          idType: ProductIdTypeEnum.ID,
        },
      })),
    ];
  }, [product.events]);

  const purchaseCompleteHandler = () => {
    setHasJustPurchased(true);
  };

  if (hasJustPurchased) {
    return <Loading />;
  }

  return (
    <>
      <ProductPurchaseModal
        productId={product?.id}
        productDatabaseId={product?.databaseId}
        productName={product?.name}
        productPrice={product?.priceUSD}
        hasPurchased={Boolean(product?.hasPurchased)}
        canPurchaseWithCredits={canPurchaseWithCredits}
        subscriptionDiscount={discountInfo.activeDiscountFromSubscription}
        creditCost={creditCost}
        type={type}
        open={paymentModalOpen}
        onRequestClose={onCloseModal}
        title={modalTitle}
        refetchQueries={refetchQueries}
        onPurchaseComplete={purchaseCompleteHandler}
      />
      <Price
        price={event.eventFields?.price}
        discountOptions={discountInfo}
        discountOnChange={setActiveSubscriptionDiscountId}
      />
      {product.couponForUser && <CouponDiscount couponForUser={product.couponForUser} />}
      <Button className="my-4 w-full" theme="primary" onClick={onClickPurchase}>
        Register Now
      </Button>
      <p>
        <b>{title ?? "Tokens may not be used with webinars."}</b>
      </p>
    </>
  );
};

export default SidebarRegister;
